"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.get_archive = void 0;
var api_1 = require("../../api");
var get_archive = function (req) {
    return (0, api_1.apiGet)({
        endpoint: "v3/archive/get",
        // data: formData,
        query: req,
    });
};
exports.get_archive = get_archive;
